export default {
  mobile_app_average_order_value: {
    label: 'Gns. ordreværdi via app',
  },
  mobile_app_gmv: {
    label: 'App-salg',
  },
  mobile_app_gmv_percentage: {
    label: 'Omsætning % via app',
  },
  mobile_app_downloads: {
    label: 'Downloads',
  },
  mobile_app_orders_count: {
    label: 'App-ordrer',
  },
  name: {
    label: 'Restaurant',
  },
  mobile_app_released_at: {
    label: 'Lanceringsdato',
  },
  title: 'Restaurantoversigt',
};
